export const SDKORDERID = 'SDKORDERID';
export const orderIdAction = (orderIdFromSdk) => {
  return { type: SDKORDERID, payload: orderIdFromSdk };
};
